import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from 'react-router-dom';
import './App.css';
import StressCalculator from './components/StressCalculator';
import MaterialCalculator from './components/MaterialCalculator';
import Formatter from './components/Formatter';
import CantileverStressCalculator from './components/CantileverStressCalculator';
import MaterialWeightCalculator from './components/MaterialWeightCalculator';

function HomePage() {
  const navigate = useNavigate();

  const handleToolClick = (toolType: string) => {
    navigate(`/${toolType}`);
  };

  return (
    <div className="App">
      <div className="header">
        <h1>材料工具箱</h1>
        <p>专业的材料计算与应力分析工具</p>
      </div>
      <div className="tools-container">
        {/* <div className="tool-card" onClick={() => handleToolClick('stress')}>
          <div className="tool-icon">🔧</div>
          <h3>材料应力计算</h3>
          <p>计算材料在各种载荷条件下的应力分布和强度分析</p>
        </div>
        <div className="tool-card" onClick={() => handleToolClick('material')}>
          <div className="tool-icon">📊</div>
          <h3>材料计算</h3>
          <p>材料属性计算、重量估算和成本分析</p>
        </div> */}
        <div
          className="tool-card"
          onClick={() => handleToolClick('cantilever')}
        >
          <div className="tool-icon">🏗️</div>
          <h3>悬臂梁应力计算</h3>
          <p>基于材料属性和几何参数计算正向力和应力</p>
        </div>
        <div className="tool-card" onClick={() => handleToolClick('weight')}>
          <div className="tool-icon">⚖️</div>
          <h3>材料重量计算器</h3>
          <p>材料重量、长度、外径计算工具</p>
        </div>
        <div className="tool-card" onClick={() => handleToolClick('formatter')}>
          <div className="tool-icon">📝</div>
          <h3>格式化工具</h3>
          <p>数字格式化、单位转换和工程计数法工具</p>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/stress" element={<StressCalculator />} />
        <Route path="/material" element={<MaterialCalculator />} />
        <Route path="/formatter" element={<Formatter />} />
        <Route path="/cantilever" element={<CantileverStressCalculator />} />
        <Route path="/weight" element={<MaterialWeightCalculator />} />
      </Routes>
    </Router>
  );
}

export default App;
